export const relationshipTypes = [
  "Partner",
  "Child",
  "Sibling",
  "Volunteer",
  "Niece/Nephew",
  "Parent",
  "Friend",
  "Daughter",
  // TODO: Unhide after release
  // "Granddaughter",
  // "Grandson",
  "Other"
];